<template>
    <div class="contentWidth clearfix">
        <div class="company fleft">
          <img src="@/assets/images/caizhidasha_JPG.png"  width="100%"/>
          <div class="address">
            <div>
              <h1>
                羊村集团总部
              </h1>
              <h1>CONTACT US</h1>
            </div>
            <table>
               <tr>
                 <td width="80">联系电话：</td><td>029-85512022</td>
               </tr>
               <tr>
                 <td>简历投至：</td><td>hr@yycunluo.com</td>
               </tr>
               <tr>
                 <td>公司地址：</td><td>陕西省西安市经济技术开发区凤城八路西北国金C座22076室</td>
               </tr>
            </table>
          </div>
        </div>
        <div class="map fright">
          <div style="width:732px;height:526px" id="dituContent"></div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'map',
  data () {
    return {}
  },
  methods: {
    initMap () {
      this.createMap()
      this.setMapEvent() // 设置地图事件
      this.addMapControl() // 向地图添加控件
      this.addMarker() // 向地图中添加marker
    },
    createMap () {
      var map = new BMap.Map('dituContent') // 在百度地图容器中创建一个地图
      var point = new BMap.Point(108.94415, 34.34485) // 定义一个中心点坐标
      map.centerAndZoom(point, 17) // 设定地图的中心点和坐标并将地图显示在地图容器中
      // map.setCurrentCity('西安')
      window.map = map // 将map变量存储在全局
    },
    setMapEvent () {
      map.enableDragging() // 启用地图拖拽事件，默认启用(可不写)
      map.enableScrollWheelZoom() // 启用地图滚轮放大缩小
      map.enableDoubleClickZoom() // 启用鼠标双击放大，默认启用(可不写)
      map.enableKeyboard() // 启用键盘上下左右键移动地图
    },
    addMapControl () {
      // 向地图中添加缩放控件
      var ctrl_nav = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_TOP_LEFT, type: BMAP_NAVIGATION_CONTROL_LARGE })
      map.addControl(ctrl_nav)
      // 向地图中添加比例尺控件
      var ctrl_sca = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_LEFT })
      map.addControl(ctrl_sca)
    },
    // 标注点数组
    // 创建marker
    addMarker () {
      var markerArr = [{title: '羊村集团总部', content: '地址：西安市莲湖区大庆路2号恒天财智大厦10902室<br/>029-85512022', point: '108.927749|34.274532', isOpen: 1, icon: {w: 23, h: 25, l: 46, t: 21, x: 9, lb: 12}}]
      for (var i = 0; i < markerArr.length; i++) {
        var json = markerArr[i]
        var p0 = json.point.split('|')[0]
        var p1 = json.point.split('|')[1]
        var point = new BMap.Point(p0, p1)
        // 这个地方加this
        var iconImg = this.createIcon(json.icon)
        var marker = new BMap.Marker(point, {icon: iconImg})
        // 这个地方加this
        var iw = this.createInfoWindow(i)
        var label = new BMap.Label(json.title, {'offset': new BMap.Size(json.icon.lb - json.icon.x + 10, -20)})
        marker.setLabel(label)
        map.addOverlay(marker)
        label.setStyle({
          borderColor: '#808080',
          color: '#333',
          cursor: 'pointer'
        })
        // 这个地方加this
        var _iw = this.createInfoWindow(i)
        var _marker = marker
        marker.addEventListener('click', function () {
        // 这个地方加this
          this.openInfoWindow(_iw)
        })
        iw.addEventListener('open', function () {
          _marker.getLabel().hide()
        })
        _iw.addEventListener('close', function () {
          _marker.getLabel().show()
        })
        label.addEventListener('click', function () {
          _marker.openInfoWindow(_iw)
        })
        if (!json.isOpen) {
          label.hide()
          _marker.openInfoWindow(_iw)
        }
      }
    },
    // 创建InfoWindow
    createInfoWindow (i) {
      // 这个地方复制一下上面的var markerArr 不然会不显示报错
      var markerArr = [{title: '羊村集团总部', content: '地址：西安市莲湖区大庆路2号恒天财智大厦10902室<br/>电话：029-85512022', point: '108.927749|34.274532', isOpen: 1, icon: {w: 23, h: 25, l: 46, t: 21, x: 9, lb: 12}}]
      var json = markerArr[i]
      var iw = new BMap.InfoWindow("<b class='iw_poi_title' title='" + json.title + "'>" + json.title + "</b><div class='iw_poi_content'>" + json.content + "</div>")
      return iw
    },
    // 创建一个Icon
    createIcon (json) {
      // 这个地方我是用本地图标图片的
      var icon = new BMap.Icon('http://app.baidu.com/map/images/us_mk_icon.png', new BMap.Size(json.w, json.h), {imageOffset: new BMap.Size(-json.l, -json.t), infoWindowOffset: new BMap.Size(json.lb+5, 1), offset: new BMap.Size(json.x, json.h)})
      return icon
    }
  },
  mounted () {
    this.initMap()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
.company{
      width:358px;
      .address{
        padding: 33px 30px;
        margin-top: 5px;
        background-color: #f5f5f5;
        height:292px;
        div{
          border-left: 3px solid #333;
          padding-left: 10px;
          h1{
             font-size: 26px;
             line-height: 26px;
             margin: 0;
             &:first-child{margin-bottom:13px;}
          }
        }
        table{
          margin-top: 20px;
          line-height: 38px;
          td{
             vertical-align: top;
          }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/map.vue